import MobileDetect from 'mobile-detect';

export class MobileUtil {

  private _md;

  public constructor(userAgent: string) {
    this._md = new MobileDetect(userAgent);
  }

  get md() {
    return this._md;
  }

  isMobile(): boolean {
    return this._md.phone() != null;
  }


//   isShowNav(): boolean {
//     return store.state.showNav;
//   }
//
//   isUserCurrent(): boolean {
//     return !(!store.state.currentUser);
//   }
//
//   showAuthenticatedTopNav(): boolean {
//     return this.isShowNav() && this.isUserCurrent() && !this.isMobile();
//   }
//
//   showAuthenticatedBottomNav(): boolean {
//     return this.isShowNav() && this.isUserCurrent() && this.isMobile();
//   }
//
//   showUnauthenticatedTopNav(): boolean {
//     return this.isShowNav() && !this.isUserCurrent();
//   }
}
